// extracted by mini-css-extract-plugin
module.exports = {"editor":"editorStyles_editor__2nbFZ","readOnly":"editorStyles_readOnly__bo9Tn"};